import React from 'react'
import { Formik, Field } from 'formik'
import { useIntl } from 'react-intl'
import { Button, Form, FadeIn } from 'lib/ui/components'
import { usePwaForm } from 'hooks/pwaForm'
import { useStoreView } from 'hooks/useStoreView'
import { Wrapper } from './styled'
import { schema, validation, FormValues } from './schema'

interface Props {
  setOrderInfo: (params: any) => void
}

export const OrdersForm: React.FC<Props> = ({ setOrderInfo }) => {
  const intl = useIntl()
  const { isLivBrite } = useStoreView()
  const {
    submitForm,
    isFetching,
    isSuccess
  } = usePwaForm(isLivBrite ? 'rma_form_livbrite' : 'rma_form_sg')

  /* const handleSubmit = (values: FormValues) => {
    const {
      lastname,
      orderId,
      search,
      type
    } = values

    setOrderInfo({
      lastname,
      orderId,
      search,
      type: type === 'true'
    })
  } */

  function handleSubmit (values: FormValues) {
    const formFields = [
      { code: 'orderId', value: values.orderId },
      { code: 'email', value: values.email },
      { code: 'lastname', value: values.lastname },
      { code: 'comment', value: values.comment }
    ]
    submitForm(formFields)
  }

  return (
    <Wrapper isLivBrite={isLivBrite}>
      <FadeIn>
        {isSuccess ? (
          <h2 className='success'>
            Your request was submitted successfully. <br /> We will contact you as soon as possible.
          </h2>
        ) : (
          <Formik
            initialValues={schema}
            validationSchema={validation(intl)}
            onSubmit={handleSubmit}
          >
            <Form.Wrapper>
              <Field
                name='orderId'
                label='Order ID'
                component={Form.Input}
                isRequired
              />
              <Field
                name='lastname'
                label='Billing Last Name'
                component={Form.Input}
                isRequired
              />
              <Field
                name='email'
                label='Email'
                component={Form.Input}
                isRequired
              />
              <Field
                name='comment'
                label='Reason for Return'
                component={Form.TextArea}
                isRequired
              />
              <div>
                <Button
                  type='submit'
                  isLoading={isFetching}
                >
                  Submit Return Request
                </Button>
              </div>
            </Form.Wrapper>
          </Formik>
        )}
      </FadeIn>
    </Wrapper>
  )
}
